import {
  isLetteredListActive,
  isNumberedListActive,
  toggleBulletList,
  toggleLetteredList,
  toggleNumberedList,
} from '@/lib/richTextLists'

/** Shared TipTap list controls: bullets, numbers, letters. */
export function RichTextListButtons({ editor, ToolbarButton }) {
  if (!editor || !ToolbarButton) return null

  return (
    <>
      <ToolbarButton
        active={editor.isActive('bulletList')}
        onClick={() => toggleBulletList(editor)}
        title="Bullet list"
      >
        Bullets
      </ToolbarButton>
      <ToolbarButton
        active={isNumberedListActive(editor)}
        onClick={() => toggleNumberedList(editor)}
        title="Numbered list"
      >
        1. 2. 3.
      </ToolbarButton>
      <ToolbarButton
        active={isLetteredListActive(editor)}
        onClick={() => toggleLetteredList(editor)}
        title="Lettered list"
      >
        a. b. c.
      </ToolbarButton>
    </>
  )
}
